import React from 'react'

const DocusignComplete = () => {
  return (
    <div>
      <h1>Signing complete, please go dashboard</h1>
    </div>
  )
}

export default DocusignComplete
